import axios from 'axios';

const API_URL = process.env.REACT_APP_STRAPI_API_URL || 'https://www.eatmeatapp.com';

const authHeaders = () => {
  const jwt = localStorage.getItem('jwt');
  return jwt ? { Authorization: `Bearer ${jwt}` } : {};
};

const userId = () => localStorage.getItem('userId');

// ── Elimination Calendar Logs ──

export const fetchLogs = async (dateFrom: string, dateTo: string, logType?: string) => {
  const params: any = {
    'filters[user][id][$eq]': userId(),
    'filters[date][$gte]': dateFrom,
    'filters[date][$lte]': dateTo,
    sort: 'date:asc,createdAt:asc',
    'pagination[pageSize]': 1000,
  };
  if (logType) params['filters[log_type][$eq]'] = logType;
  const response = await axios.get(`${API_URL}/api/elimination-calendars`, {
    params,
    headers: authHeaders(),
  });
  return response.data.data || [];
};

export const createLog = async (data: any) => {
  const response = await axios.post(`${API_URL}/api/elimination-calendars`, {
    data: { ...data, user: userId() },
  }, { headers: { ...authHeaders(), 'Content-Type': 'application/json' } });
  return response.data.data;
};

export const updateLog = async (id: string, data: any) => {
  const response = await axios.put(`${API_URL}/api/elimination-calendars/${id}`, {
    data,
  }, { headers: { ...authHeaders(), 'Content-Type': 'application/json' } });
  return response.data.data;
};

export const deleteLog = async (id: string) => {
  await axios.delete(`${API_URL}/api/elimination-calendars/${id}`, {
    headers: authHeaders(),
  });
};

// ── Macro Goals ──

export const fetchMacroGoals = async () => {
  const response = await axios.get(`${API_URL}/api/macro-goals`, {
    params: { 'filters[user][id][$eq]': userId() },
    headers: authHeaders(),
  });
  return response.data.data?.[0] || null;
};

export const createMacroGoals = async (data: { daily_protein_goal: number; daily_fat_goal: number; daily_calorie_goal: number }) => {
  const response = await axios.post(`${API_URL}/api/macro-goals`, {
    data: { ...data, user: userId() },
  }, { headers: { ...authHeaders(), 'Content-Type': 'application/json' } });
  return response.data.data;
};

export const updateMacroGoals = async (id: string, data: any) => {
  const response = await axios.put(`${API_URL}/api/macro-goals/${id}`, {
    data,
  }, { headers: { ...authHeaders(), 'Content-Type': 'application/json' } });
  return response.data.data;
};
